import React, { Component } from "react";
import { Icon } from "../../../components/Icon";

export default class CoachHeader extends Component {
  render() {
    const { onReset, onClose, onShowSessions } = this.props;

    return (
      <div className="coach-header">
        <span className="coach-model-label" title="storyclub coach">
          Storyclub coach
        </span>
        <span style={{ flex: 1 }} />

        {onShowSessions && (
          <button className="btn subtle" onClick={onShowSessions} title="View session history">
            History
          </button>
        )}
        <button className="btn subtle" onClick={onReset} title="Restart coach">
          <Icon.Restart />
        </button>
        <button className="btn subtle" onClick={onClose} title="Close coach">
          <Icon.Close />
        </button>
      </div>
    );
  }
}
